/**
 * bootprompt.js locale configuration
 * locale : French
 * author : Nick Payne, Sebastien Andary
 */

import { addLocale } from "../bootprompt";

addLocale("fr", {
  OK: "OK",
  CANCEL: "Annuler",
  CONFIRM: "Confirmer",
});
